((window, $) => {
  const cookies = document.cookie.split('; ');
  const confirmAgeCookie = cookies.filter((cookie) => {
    const key = cookie.split('=')[0];
    return key[0] === 'confirm-age';
  });
  if (confirmAgeCookie.length === 0) {
    const ageConfModal = $('#age-confirmation-modal');
    ageConfModal.modal();
    const ageConfSuccessButton = $('#confirm-age-success');
    const ageConfNoneButton = $('#confirm-age-none');
    ageConfNoneButton.on('click', () => {
      window.location.replace(restriction_exit_link);
    });
    ageConfSuccessButton.on('click', () => {
      const expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
      document.cookie = `confirm-age=1; expires=${expires}; path=/`;
      ageConfModal.modal('toggle');
    });
  }
})(window, window.jQuery);
